export function apiBaseUrl (): string {
  if (import.meta.env.SSR) {
    return import.meta.env.VITE_APP_SERVER_API_URL
  }
  return import.meta.env.VITE_APP_CLIENT_API_URL || import.meta.env.VITE_APP_SERVER_API_URL
}
